import { render, staticRenderFns } from "./SideMenuDataView.vue?vue&type=template&id=339bf731&"
import script from "./SideMenuDataView.vue?vue&type=script&lang=js&"
export * from "./SideMenuDataView.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\a\\1\\s\\Simply\\Simply.Web.Website\\Static\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('339bf731')) {
      api.createRecord('339bf731', component.options)
    } else {
      api.reload('339bf731', component.options)
    }
    module.hot.accept("./SideMenuDataView.vue?vue&type=template&id=339bf731&", function () {
      api.rerender('339bf731', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/Js/Components/SideMenuDataView.vue"
export default component.exports